// extracted by mini-css-extract-plugin
module.exports = {"subscriptionPlanCardInfo":"SubscriptionPlanBenefits_subscriptionPlanCardInfo__kJN43"};